const MENU_PERMISSIONS_LIST = [
  {
    code: 'MAINPAGE',
    linkData: {
      path: 'admin/main',
      title: 'sidebar.admin.main',
    },
    iconName: 'bi bi-house',
    order: 1,
  },
  {
    code: 'PRODUCTS',
    linkData: {
      path: 'admin/products',
      title: 'sidebar.admin.products',
    },
    iconName: 'bi bi-box',
    order: 1,
  },
  {
    code: 'EXPENSES',
    linkData: {
      path: 'admin/expenses',
      title: 'Xarajatlar',
    },
    iconName: 'bi bi-airplane',
    order: 1,
  },
  {
    code: 'WAREHOUSE',
    linkData: {
      path: 'admin/warehouse',
      title: 'sidebar.admin.warehouse',
    },
    iconName: 'bi bi-building',
    order: 2,
  },
  {
    code: 'FINANCE',
    linkData: {
      path: 'admin/money',
      title: 'Moliya',
    },
    iconName: 'bi bi-cash',
    order: 2,
  },
  {
    code: 'PARTNERMONEY',
    linkData: {
      path: 'admin/partner-money',
      title: 'Hamkorlar bilan Ishlash',
    },
    iconName: 'bi bi-people',
    order: 2,
  },
  {
    code: 'INCOMEMONEY',
    linkData: {
      path: 'admin/incomemoney',
      title: "Sotuv bo'limi",
    },
    iconName: 'bi bi-shop',
    order: 2,
  },
  {
    code: 'ORDERS',
    linkData: {
      path: 'admin/order',
      title: 'Buyurtmalar',
    },
    iconName: 'bi bi-journal-bookmark',
    order: 2,
  },
  {
    code: 'RECEIVED_MONEY',
    linkData: {
      path: 'admin/account-income',
      title: 'Qabul qilingan pullar',
    },
    iconName: 'bi bi-credit-card',
    order: 2,
  },
  {
    code: 'ACCOUNTS',
    linkData: {
      path: 'admin/account-conversation',
      title: 'Konversiyalar',
    },
    iconName: 'bi bi-currency-exchange',
    order: 2,
  },
  {
    code: 'ACCOUNTS',
    linkData: {
      path: 'admin/accounts',
      title: 'Kassalar',
    },
    iconName: 'bi bi-person-vcard',
    order: 2,
  },
  {
    code: 'STATISTICS',
    bottom: true,
    linkData: {
      path: 'statistic/object',
      title: 'Statistika',
    },
    iconName: 'bi bi-graph-up-arrow',
    order: 15,
  },
  {
    code: 'SETTINGS',
    bottom: true,
    linkData: {
      path: 'admin/settings',
      title: 'sidebar.admin.settings',
    },
    iconName: 'bi bi-gear',
    order: 15,
  },
];

export default MENU_PERMISSIONS_LIST;
